import { DocumentRequirement } from "./Document";

export interface ApplicationField {
  id: string;
  label: string;
  type: 'text' | 'email' | 'phone' | 'number' | 'integer' | 'percent' | 'currency' | 'date' | 'select' | 'textarea' | 'file' | 'heading';
  required: boolean;
  value?: any;
  options?: string[];
  additional_info?: string;
  validation?: any;
  helpText?: string;
  documentContext?: string;
  placeholder?: string;
  readonly?: boolean;
  // baseReadonly is the original readonly state from field definition, before annotation overrides are applied
  // Used to determine if the "Allow updates" checkbox should be shown for LO users
  baseReadonly?: boolean;
  hideLabel?: boolean;
}

export interface BaseSection {
  id: string;
  title: string;
  description: string;
  status?: 'not_started' | 'in_progress' | 'completed' | 'needs_review';
  isLevel1Section?: boolean;
  completedFields?: number;
  totalFields?: number;
  required?: boolean;
  displayOrder?: number;
}

export interface ApplicationSection extends BaseSection {
  fields: ApplicationField[];
  group?: string;
  documents?: DocumentRequirement[];
  isDynamicallyRenderedSection?: boolean;
}

export interface SectionGroup extends BaseSection {
  sections: ApplicationSection[];
}

export function isSectionGroup(section: ApplicationSection | SectionGroup): section is SectionGroup {
  return Array.isArray((section as SectionGroup).sections);
}
